// extracted by mini-css-extract-plugin
export var fullHeightState = "_1h-7";
export var headerCell = "_1h-1";
export var loadingStateCell = "_1h-4";
export var rowWrapper = "_1h-3";
export var standaloneTable = "_1h-8";
export var standaloneTableWithBodyFill = "_1h-9";
export var stateCell = "_1h-5";
export var table = "_1h-0";
export var tableBodyFiller = "_1h-6";
export var white = "_1h-2";